import React from "react";
/* import {
  List
} from "@material-ui/core"; */
import moment from 'moment';
import 'moment/locale/es';
//import moment from 'moment/min/moment-with-locales';
import './styles.css';
/* import {
  faCloud,
  faBolt,
  faCloudRain,
  faCloudShowersHeavy,
  faSnowflake,
  faSun,
  faSmog,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; */
//import styled from 'styled-components';

import { 
  WiDayThunderstorm,
  WiDaySprinkle,
  WiDayRain,
  WiDaySnow,
  WiDaySunny,
  WiCloudy,
  WiCloud,
} from 'weather-icons-react';

//import PropTypes from 'prop-types';
//moment.locale('sp');
import { useSelector } from 'react-redux';


export default function Forecast() {
  
  
  
  const { weather, language } = useSelector( state => state.data);
  let results = [];

  if (weather !== null) {
    results = weather.daily.map((item, index) => {
    
      const iconSize = 30;
      const iconColor = "#11266d";
      //limite a 4 dias
      if (index >= 1 && index < 6){
        let weatherIcon = null;
  
        if (item.weather[0].main === 'Thunderstorm') {
          weatherIcon = <WiDayThunderstorm size={iconSize} color={iconColor} />;
        } else if (item.weather[0].main === 'Drizzle') {
          weatherIcon = <WiDaySprinkle size={iconSize} color={iconColor} />;
        } else if (item.weather[0].main === 'Rain') {
          weatherIcon = <WiDayRain size={iconSize} color={iconColor} />;
        } else if (item.weather[0].main === 'Snow') {
          weatherIcon = <WiDaySnow size={iconSize} color={iconColor} />;
        } else if (item.weather[0].main === 'Clear') {
          weatherIcon = <WiDaySunny size={iconSize} color={iconColor} />;
        } else if (item.weather[0].main === 'Clouds') {
          weatherIcon = <WiCloudy size={iconSize} color={iconColor} />;
        } else {
          weatherIcon = <WiCloud size={iconSize} color={iconColor} />;
        }
  
        return (
            <div key={index} className="flex-forecast">
              <div style={{fontSize: '12px', fontWeight: '500'}}>{moment.unix(item.dt).locale(language).format("dddd").slice(0,3).charAt(0).toUpperCase()+moment.unix(item.dt).locale(language).format("dddd").slice(1,3)}</div>
              <div className="icon-forecast">
                {weatherIcon}
              </div>
              <div style={{fontSize: '11px', fontWeight: '400', textAlign:'center'}}>
                {item.weather[0].description}
              </div>
              <div style={{fontSize: '11px', fontWeight: '400', padding:'5px'}}>
                {Number(item.temp.max).toFixed(0)}&deg;/{Number(item.temp.min).toFixed(0)}&deg;
              </div>
            </div>
        
        )
  
      }
      
    })
  }

  //console.log("Forecast", weatherData.daily);

  
  
  return(
       
          <div className="forecast">
            {results}
          </div>
      
    
  );
  
}

